import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private readonly STORAGE_KEY = 'theme-preference';

  private themeSubject = new BehaviorSubject<'dark' | 'light'>(this.getStoredTheme());
  readonly theme$: Observable<'dark' | 'light'> = this.themeSubject.asObservable();

  constructor() {
    this.applyTheme();
  }

  public toggle(): void {
    const current = this.themeSubject.value;
    const next = current === 'dark' ? 'light' : 'dark';
    this.themeSubject.next(next);
    this.storeTheme(next);
    this.applyTheme();
  }

  public setTheme(theme: 'dark' | 'light'): void {
    this.themeSubject.next(theme);
    this.storeTheme(theme);
    this.applyTheme();
  }

  public isDark(): boolean {
    return this.themeSubject.value === 'dark';
  }

  private getStoredTheme(): 'dark' | 'light' {
    const stored = localStorage.getItem(this.STORAGE_KEY);
    if (stored === 'dark' || stored === 'light') {
      return stored;
    }
    return 'light';
  }

  private storeTheme(theme: 'dark' | 'light'): void {
    localStorage.setItem(this.STORAGE_KEY, theme);
  }

  private applyTheme(): void {
    document.body.classList.remove('dark-mode', 'light-mode');
    document.body.classList.add(`${this.themeSubject.value}-mode`);
  }
}
